const genericDownloadError = 'GENERIC_ERROR_MESSAGE';
const notAuthorizedError = 'Not Authorized.';

const isAuthStatus = status => {
    if (typeof status === 'number') {
        return status === 401 || status === 403;
    }

    if (typeof status === 'string') {
        return /^(401|403)\b/.test(status.trim());
    }

    return false;
};

const getDownloadFallbackError = (status, genericMessage = genericDownloadError) => {
    return isAuthStatus(status)
        ? { code: 'API-998', message: notAuthorizedError }
        : { code: 'API-999', message: genericMessage };
};

const decodeBinaryData = errorData => {
    const bytes = errorData instanceof ArrayBuffer
        ? new Uint8Array(errorData)
        : new Uint8Array(errorData.buffer, errorData.byteOffset, errorData.byteLength);

    if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder('utf-8').decode(bytes);
    }

    return String.fromCharCode.apply(null, bytes);
};

const getDecodedErrorData = errorData => {
    if (typeof errorData === 'string') {
        return errorData;
    }

    if (typeof ArrayBuffer !== 'undefined' && errorData instanceof ArrayBuffer) {
        return decodeBinaryData(errorData);
    }

    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView(errorData)) {
        return decodeBinaryData(errorData);
    }

    if (errorData && typeof errorData === 'object') {
        return errorData;
    }

    return undefined;
};

const getDownloadErrorForCallback = (error, genericMessage = genericDownloadError) => {
    const status = error && error.response && error.response.status;
    const fallbackError = getDownloadFallbackError(status, genericMessage);
    const errorData = error && error.response && error.response.data;

    if (!errorData || isAuthStatus(status)) {
        return fallbackError;
    }

    try {
        const decodedErrorData = getDecodedErrorData(errorData);
        const errorInstance = typeof decodedErrorData === 'string'
            ? JSON.parse(decodedErrorData)
            : decodedErrorData;

        return {
            code: errorInstance && errorInstance.error && errorInstance.error.code || fallbackError.code,
            message: errorInstance && errorInstance.error && errorInstance.error.message || fallbackError.message
        };
    } catch {
        return fallbackError;
    }
};

module.exports = {
    getDownloadErrorForCallback,
    getDownloadFallbackError,
    isAuthStatus
};
